// Mock data for Paralegal Services Website - Services for Attorneys

export const heroData = {
  headline: "Expert Paralegal Services",
  subheadline: "15+ Years of Real Estate Excellence",
  tagline: "Dedicated Support for Attorneys",
  description: "Specialized paralegal support exclusively for attorneys handling commercial and residential real estate transactions. Professional, thorough, and dedicated to your firm's success.",
  ctaText: "Contact Us",
  backgroundImage: "https://images.unsplash.com/photo-1603796846097-bee99e4a601f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwxfHxkb2N1bWVudHN8ZW58MHx8fHwxNzY4Njg2OTEyfDA&ixlib=rb-4.1.0&q=85"
};

export const servicesData = [
  {
    id: 1,
    title: "Commercial Real Estate",
    description: "Comprehensive paralegal support for attorneys handling commercial property transactions. From due diligence to closing coordination, we provide the detailed assistance your firm needs.",
    features: ["Contract Review & Drafting Support", "Title Searches & Examination", "Due Diligence Documentation", "Closing Coordination & Support"],
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzY4NzA3MTY5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Residential Real Estate",
    description: "Expert paralegal assistance for attorneys managing residential property closings. We handle the documentation details so you can focus on your clients.",
    features: ["Purchase & Sale Agreement Support", "Title Examination & Reports", "Document Preparation & Review", "Closing Package Assembly"],
    image: "https://images.unsplash.com/photo-1695388474402-ed805a890d8d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwyfHxkb2N1bWVudHN8ZW58MHx8fHwxNzY4Njg2OTEyfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Leasing Services",
    description: "Professional paralegal support for attorneys handling commercial and residential lease matters. Thorough documentation review and preparation for your leasing practice.",
    features: ["Lease Drafting & Review Support", "Amendment & Addendum Preparation", "Renewal Documentation", "Compliance Review Assistance"],
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzY4NzA3MTY5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Real Estate Litigation Support",
    description: "Comprehensive paralegal assistance for attorneys handling real estate disputes and litigation. We provide the detailed support your litigation practice demands.",
    features: ["Case Analysis", "Document Discovery & Organization", "Deposition Preparation Support", "Trial Binder & Exhibit Preparation"],
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?crop=entropy&cs=srgb&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.1.0&q=85"
  }
];

export const aboutData = {
  headline: "15+ Years Supporting Legal Professionals",
  description: "With over fifteen years of specialized experience providing paralegal services to attorneys, I bring unmatched expertise in real estate transactions. My commitment is to provide thorough, professional support that helps your firm deliver exceptional results for your clients.",
  highlights: [
    { number: "15+", label: "Years Experience" },
    { number: "1000+", label: "Transactions Supported" },
    { number: "100%", label: "Attorney Satisfaction" }
  ],
  values: [
    "Meticulous attention to detail",
    "Clear and timely communication",
    "Deep understanding of real estate law",
    "Dedicated support for your practice"
  ]
};

export const contactInfo = {
  email: "info@therealestateparalegal.com",
  phone: "(520) 261-2732"
};
